export const d4cSizes = {
	navbar: {
		height: {
			base: '128px',
			sm: '80px',
		},
		width: '280px',
		collapsed: {
			width: '72px',
		},
	},
	analytic: {
		filters: {
			width: '250px',
		},
	},
};
